<div class="carousel-container" [ngClass]="{
  'carousel-section d-flex align-items-center justify-content-center': variant === 'section',
  'carousel-inline': variant === 'inline',
  'carousel-text': type === 'text',
  'carousel-word': type === 'word',
  'carousel-image': type === 'image'
}" [style.background]="variant === 'section' && background ? background : null">

    <div class="carousel-wrapper d-flex flex-column align-items-center justify-content-center w-100">

        <!-- Carousel de TEXTO (frases largas - home.primera) -->
        @if(type === 'text') {
        <div class="carousel-slides w-100">
            @for(item of items; track $index) {
            <div class="carousel-slide text-slide d-flex align-items-center justify-content-center"
                [class.active]="currentIndex === $index">
                <p class="carousel-text-content">{{ item.content }}</p>
            </div>
            }
        </div>
        }

        <!-- Carousel de PALABRAS (palabras destacadas - home.sisena) -->
        @if(type === 'word') {
        <div class="carousel-slides w-100">
            @for(item of items; track $index) {
            <div class="carousel-slide word-slide" [class.active]="currentIndex === $index"
                [class.prev]="getPrevIndex() === $index">
                <p class="carousel-word-content">{{ item.content }}</p>
            </div>
            }
        </div>
        }

        <!-- Carousel de IMÁGENES (logos - coaches.colabs) -->
        @if(type === 'image') {
        <div class="carousel-slides w-100">
            @for(item of items; track $index) {
            <img [src]="item.content" [alt]="item.alt || 'Carousel image'" class="carousel-slide image-slide"
                [class.active]="currentIndex === $index">
            }
        </div>
        }

        <!-- Indicadores de navegación -->
        @if(showIndicators && items.length > 1) {
        <div class="carousel-indicators d-flex justify-content-center align-items-center">
            @for(item of items; track $index) {
            <span class="indicator" [class.active]="currentIndex === $index" (click)="goTo($index)"></span>
            }
        </div>
        }

    </div>

</div>